<div class="row">
    <div class="col-sm-12">
    <h2> Frequently Asked Questions</h2>
    <ul class="list-group list-group-flush">


    <li class="list-group-item"><a routerLink="/info/usage/policy" fragment="#membership">How Do I  get a refund?</a></li>
    <li class="list-group-item"><a routerLink="/info/usage/policy" fragment="#billing">How Do I Cancel my Account?</a></li>
    <li class="list-group-item"><a routerLink="/info/usage/policy" fragment="#billing"> How Do I Cancel My Subscription?</a></li>
    <li class="list-group-item"><a routerLink="/info/usage/policy" fragment="#is-data-protected"> Is my personal information protected</a></li>
    <li class="list-group-item"><a routerLink="/info/usage/policy" fragment="#how-do-i-report-a-problem">How do I report that a problem has a mistake, has a wrong answer, or is unclear?</a></li>
    </ul>
    <div>
        <a name="is-data-protected"></a>
        <h3>Is my personal information protected</h3>
        Your personal information is well-protected and you can read all about it <a routerLink="/info/privacy/policy">here</a>.

        <a name="how-do-i-report-a-problem"></a>
        <h3>How do I report that a problem has a mistake, has a wrong answer, or is unclear?</h3>
        If you're working on a problem and find a mistake or a bug, or feel that things aren't stated clearly, you can file a report which will go to the relevant expert for your issue  (e.g. a mathematician, a scientist, the product team, etc.)

        The approach depends on whether you're accessing Boldungu by browser or through our mobile apps. The easiest approach is to send an email indicating the  problem id, and it will be forwarded to the relevant expert.

        </div>
    </div>

 </div>
